import { ISummerCampEnquiry } from '@wot/typings';
import { BiSort } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { CheckBox } from '@wot/components';
import { Table, TableBody, TableHeading, TableHeadingCol, TableRow } from '../../../../components/Table';
import TableRowItem from './TableRowItem';

interface Props {
  data: ISummerCampEnquiry[];
  handleSort: (key: string) => void;
  selectedIds: Set<string>;
  onSelect: (id: string, checked: boolean) => void;
  onSelectAll: (checked: boolean) => void;
}

export default function TableContainer({ data, handleSort, selectedIds, onSelect, onSelectAll }: Props) {
  const navigate = useNavigate();
  const allSelected = data.length > 0 && data.every((e) => selectedIds.has(e._id));

  return (
    <Table>
      <TableHeading>
        <TableRow>
          <th className="w-12 px-4 py-2" onClick={(e) => e.stopPropagation()}>
            <CheckBox defaultValue={allSelected} onChange={onSelectAll} />
          </th>
          <TableHeadingCol
            label="DATE"
            component={
              <div className="flex items-center">
                <p className="">DATE</p>
                <BiSort className="text-sm" />
              </div>
            }
            onClick={() => handleSort('createdAt')}
          />
          <TableHeadingCol label="NAME" />
          <TableHeadingCol label="EMAIL" />
          <TableHeadingCol label="PHONE" />
          <TableHeadingCol label="PROGRAM" />
          <TableHeadingCol label="SOURCE" />
          <TableHeadingCol label="MESSAGE" />
          <TableHeadingCol label="NOTES" />
          <TableHeadingCol label="STATUS" />
        </TableRow>
      </TableHeading>
      <TableBody>
        {data.map((enquiry) => (
          <TableRow key={enquiry._id} onClick={() => navigate(enquiry._id)}>
            <TableRowItem enquiry={enquiry} selected={selectedIds.has(enquiry._id)} onSelect={onSelect} />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
